// Product link target when the product is tagged to redirect to its duplicate.
// Mirrors snippets/helper-product-redirect-target.liquid for the one place links
// are built client-side (search results from the Storefront API):
//   redirect-srt -> /products/<handle>-srt, redirect-pt -> /products/<handle>-pt,
// redirect-srt wins, a handle already carrying the suffix is left alone, and
// without a tag the product's own URL is returned.
const SUFFIX_BY_TAG = [
  ["redirect-srt", "-srt"],
  ["redirect-pt", "-pt"],
];

export const redirectedProductUrl = ({handle, tags, onlineStoreUrl} = {}) => {
  const fallback = onlineStoreUrl ?? (handle ? `/products/${handle}` : "");
  if (!handle || !Array.isArray(tags)) return fallback;
  for (const [tag, suffix] of SUFFIX_BY_TAG) {
    if (tags.includes(tag)) {
      return handle.endsWith(suffix)
        ? fallback
        : `/products/${handle}${suffix}`;
    }
  }
  return fallback;
};
